import './MyAccountControl.scss'
import AccountPropertiesControl from "./AccountPropertiesControl";
import ChangePasswordControl from "./ChangePasswordControl";
import SecurityQuestionControl from "./SecurityQuestionControl";
import { useGetMyAccountSettings } from "../api/get-my-account-settings";
import TabPanel, { Item } from "devextreme-react/tab-panel";


export default function MyAccountControl() {
    const myAccountSettings = useGetMyAccountSettings();

    return (
        <div className="dx-card my-account">
            <TabPanel
                visible={!myAccountSettings.isLoading}
            >
                <Item title="Account Properties">
                    <AccountPropertiesControl />
                </Item>
                {
                    myAccountSettings.data?.canChangeWebPassword &&
                    <Item title="Change Password">
                        <ChangePasswordControl />
                    </Item>
                }
                {
                    myAccountSettings.data?.canChangeWebPassword &&
                    <Item title="Security Question/Answer">
                        <SecurityQuestionControl />
                    </Item>
                }
            </TabPanel>
        </div>
    )
}